<template>
  <div class="py-4 sm:py-6 sm:px-8 max-w-5xl mx-auto">
    <BaseLocaleLink class="text-primary flex items-center mb-4" to="/academy">
      <BaseIcon name="outline_arrow_turn_left" size="xs" class="mr-2" />
      <div>{{ $t('events.back_to_academy') }}</div>
    </BaseLocaleLink>
    <PageEditor
      :page-path="route.path"
      :is-admin="authStore.isAdmin"
      :meta-title="$t('tickets.public_offer')"
    />
  </div>
</template>
<script setup lang="ts">
import { useAuth } from '~/stores/auth'

const route = useRoute()
const authStore = useAuth()
</script>
